import { useFeatureLoyaltyUiNoRewardQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

export const useFeaturesLoyaltyNoReward = () => {
  const { featureLoyaltyUIId = '', featureIdsLoading } = useFeaturesContext();
  const { data, loading } = useFeatureLoyaltyUiNoRewardQuery({
    variables: { featureLoyaltyUIId },
    skip: !featureLoyaltyUIId,
  });
  return {
    data: data?.LoyaltyUI?.noRewardPoints,
    loading: featureIdsLoading || loading,
  };
};
